
export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};

export const formatStatus = (status: string): { label: string; className: string } => {
  switch (status) {
    case 'pending':
      return {
        label: 'En attente',
        className: 'text-yellow-700 bg-yellow-50 border-yellow-300 dark:bg-yellow-900/20 dark:border-yellow-700 dark:text-yellow-400'
      };
    case 'confirmed':
      return {
        label: 'Confirmée',
        className: 'text-blue-700 bg-blue-50 border-blue-300 dark:bg-blue-900/20 dark:border-blue-700 dark:text-blue-400'
      };
    case 'completed':
      return {
        label: 'Terminée',
        className: 'text-green-700 bg-green-50 border-green-300 dark:bg-green-900/20 dark:border-green-700 dark:text-green-400'
      };
    case 'cancelled':
      return {
        label: 'Annulée',
        className: 'text-red-700 bg-red-50 border-red-300 dark:bg-red-900/20 dark:border-red-700 dark:text-red-400'
      };
    default:
      return {
        label: 'Inconnu',
        className: 'text-gray-700 bg-gray-50 border-gray-300 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400'
      };
  }
};

export const formatPaymentStatus = (status: string): { label: string; className: string } => {
  switch (status) {
    case 'unpaid':
      return {
        label: 'Non payé',
        className: 'text-red-700 bg-red-50 border-red-300 dark:bg-red-900/20 dark:border-red-700 dark:text-red-400'
      };
    case 'partial':
      return {
        label: 'Partiel',
        className: 'text-yellow-700 bg-yellow-50 border-yellow-300 dark:bg-yellow-900/20 dark:border-yellow-700 dark:text-yellow-400'
      };
    case 'paid':
      return {
        label: 'Payé',
        className: 'text-green-700 bg-green-50 border-green-300 dark:bg-green-900/20 dark:border-green-700 dark:text-green-400'
      };
    case 'refunded':
      return {
        label: 'Remboursé',
        className: 'text-purple-700 bg-purple-50 border-purple-300 dark:bg-purple-900/20 dark:border-purple-700 dark:text-purple-400'
      };
    default:
      return {
        label: 'Inconnu',
        className: 'text-gray-700 bg-gray-50 border-gray-300 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400'
      };
  }
};
